import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type BlockchainWithId = {
  idBlockchain: number;
};

// Базовый тип для create/update операций блокчейнов
type BlockchainCreateUpdateData = BlockchainWithId & {
  name: string;
  preg: string;
  tag: string;
  decimalPlace: number;
};

// Типы для WebSocket сообщений компонента blockchains
type BlockchainAddressListMessage = WebSocketMessageWithFields<'blockchain-address-list', {
  blockchain: unknown;
}>;
type BlockchainAddressListNotFoundMessage = WebSocketMessageEmpty<'blockchain-address-list-not-found'>;
type BlockchainListMessage = WebSocketMessageWithFields<'currency-list' | 'blockchain-list' | 'pair' | 'currency-blockchain' | 'helper-wallets' | 'pair-blockchains', {
  blockchains: unknown[];
}>;
type BlockchainCreateMessage = WebSocketMessageWithFields<'blockchain-create' | 'blockchain-create-success', BlockchainCreateUpdateData>;
type BlockchainUpdateMessage = WebSocketMessageWithFields<'blockchain-update' | 'blockchain-update-success', BlockchainCreateUpdateData>;
type BlockchainDeleteMessage = WebSocketMessageWithFields<'blockchain-delete' | 'blockchain-delete-success', BlockchainWithId>;
type BlockchainLockMessage = WebSocketMessageWithFields<'blockchain-lock' | 'blockchain-lock-success', BlockchainWithId>;
type BlockchainUnlockMessage = WebSocketMessageWithFields<'blockchain-unlock' | 'blockchain-unlock-success', BlockchainWithId>;

// Объединенный тип для всех сообщений
type BlockchainsWebSocketMessage = 
  | BlockchainAddressListMessage 
  | BlockchainAddressListNotFoundMessage 
  | BlockchainListMessage 
  | BlockchainCreateMessage 
  | BlockchainUpdateMessage 
  | BlockchainDeleteMessage 
  | BlockchainLockMessage 
  | BlockchainUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataBlockchains',
},
  __name: 'blockchains',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID блокчейна
const handleWebSocketMessage = (data: BlockchainsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'blockchain-address-list':
      store.dispatch('blockchain/wsSetBlockchain', {
        blockchain: data.blockchain,
      });
      break;
    case 'blockchain-address-list-not-found':
      store.dispatch('blockchain/wsSetEmptyBlockchain');
      break;

    case 'currency-list':
    case 'blockchain-list':
    case 'pair':
    case 'currency-blockchain':
    case 'helper-wallets':
    case 'pair-blockchains':
      store.dispatch('blockchains/wsSetBlockchains', {
        blockchains: data.blockchains,
      });
      break;

    case 'blockchain-create':
    case 'blockchain-create-success':
      store.dispatch('blockchains/wsBlockchainCreate', {
        idBlockchain: data.idBlockchain,
        name: data.name,
        preg: data.preg,
        tag: data.tag,
        decimalPlace: data.decimalPlace,
      });
      break;

    case 'blockchain-update':
    case 'blockchain-update-success':
      store.dispatch('blockchains/wsBlockchainUpdate', {
        idBlockchain: data.idBlockchain,
        name: data.name,
        preg: data.preg,
        tag: data.tag,
        decimalPlace: data.decimalPlace,
      });
      break;

    case 'blockchain-delete':
    case 'blockchain-delete-success':
      store.dispatch('blockchains/wsBlockchainDelete', {
        idBlockchain: data.idBlockchain,
      });
      break;

    case 'blockchain-lock':
    case 'blockchain-lock-success':
      store.dispatch('blockchains/wsBlockchainLock', {
        idBlockchain: data.idBlockchain,
      });
      break;

    case 'blockchain-unlock':
    case 'blockchain-unlock-success':
      store.dispatch('blockchains/wsBlockchainUnlock', {
        idBlockchain: data.idBlockchain,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})